<template>
    <Layout>
        <PageHeader :title="$t('module.meetingRoomManagement')" :items="breadcrumbs" />
        <MenuCard :menuItems="menuItems" />
    </Layout>
</template>
<script>
import Layout from '@/views/layouts/main';
import PageHeader from '@/components/page-header';
import MenuCard from '@/components/MenuCard';
import i18n from '@/i18n';

export default {
    name: 'MeetingRoomManagement',
    page: { title: i18n.t('module.meetingRoomManagement') },
    components: { Layout, PageHeader, MenuCard },
    data() {
        return {
            breadcrumbs: [{ text: i18n.t('module.meetingRoomManagement'), active: true }],
            menuItems: [
                { route: 'MeetingRoom', label: i18n.t('module.meetingRoom'), icon: 'mdi-door-open', color: 'info', core: true },
                { route: 'MeetingRoomBooking', label: i18n.t('module.meetingRoomBooking'), icon: 'mdi-calendar-clock', color: 'primary', core: true },
            ],
        };
    },
};
</script>
